<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Financial"
};
</script>

<style scoped>
</style>
